import "../../Projects/JppCompta/JppCompta.css";
import Hero from "../../Projects/JppCompta/Hero.jsx";
import AboutUs from "../../Projects/JppCompta/AboutUs.jsx";
import Banner from "../../Projects/JppCompta/Banner.jsx";
import Card from "../../Projects/JppCompta/Card.jsx";
import ImgFooter from "../../Projects/JppCompta/ImgFooter.jsx";
import Footer from "../../general/Footer.jsx";

export default function JppCompta() {
  return (
    <div className="JppCompta-page">
      <Hero />
      <AboutUs />
      <Banner />
      <Card />
      <ImgFooter />
      <Footer />
    </div>
  );
}
